/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const stationPages = {
    RecentlyPlayedStationsPage: () => import('@/stations/RecentlyPlayedStationsPage'),
    StationsForYouPage: () => import('@/stations/StationsForYouPage'),
    StationsPage: () => import('@/stations/StationsPage'),
    TopStationsPage: () => import('@/stations/TopStationsPage'),
}
